/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Profile_Update_Ready_TitleInputs */

const en_us2_profile_update_ready_title = /** @type {(inputs: Profile_Update_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update ready`)
};

const pt_br2_profile_update_ready_title = /** @type {(inputs: Profile_Update_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualização pronta`)
};

const es_419_profile_update_ready_title = /** @type {(inputs: Profile_Update_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Actualización lista`)
};

const pt_pt2_profile_update_ready_title = /** @type {(inputs: Profile_Update_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Atualização pronta`)
};

const fr_fr2_profile_update_ready_title = /** @type {(inputs: Profile_Update_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise à jour prête`)
};

const de_de2_profile_update_ready_title = /** @type {(inputs: Profile_Update_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Update bereit`)
};

const it_it2_profile_update_ready_title = /** @type {(inputs: Profile_Update_Ready_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiornamento pronto`)
};

/**
* | output |
* | --- |
* | "Update ready" |
*
* @param {Profile_Update_Ready_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const profile_update_ready_title = /** @type {((inputs?: Profile_Update_Ready_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Profile_Update_Ready_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_profile_update_ready_title(inputs)
	if (locale === "es-419") return es_419_profile_update_ready_title(inputs)
	if (locale === "pt-PT") return pt_pt2_profile_update_ready_title(inputs)
	if (locale === "fr-FR") return fr_fr2_profile_update_ready_title(inputs)
	if (locale === "de-DE") return de_de2_profile_update_ready_title(inputs)
	if (locale === "it-IT") return it_it2_profile_update_ready_title(inputs)
	return en_us2_profile_update_ready_title(inputs)
});
export { profile_update_ready_title as "profile.update_ready_title" }